<div class="banner d-lg-flex d-none justify-content-center">
  <h1 class="ms-3 text-white">{{ 'featured.rewards.page.title' | translate }}</h1>
</div>
<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-3">
  <fgbcl-lottos-list [isList]="true" [defaultSort]="0"></fgbcl-lottos-list>
</div>
